/** Revise session page — resumes an active revision session via the session player. */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionLauncher, SessionPlayer, Interstitial } from '.';
import LoadingIcon from '@/foundation/ui/LoadingIcon';

/**
 * Thin wrapper for revise sessions — resume-only mode, no session creation.
 * Accepts whatever active session exists and renders the SessionPlayer.
 */
export default function ReviseSessionPage() {
  const navigate = useNavigate();
  const navigateHome = useCallback(() => navigate('/'), [navigate]);

  const {
    loading,
    sessionReady,
    session,
    sortedSteps,
    sessionType,
    startIndex,
    submitFn,
    confidencePositions,
    paasPositions,
    handleExit,
    handleComplete,
  } = useSessionLauncher({ onExit: navigateHome });

  if (loading) {
    return (
      <div
        className="flex min-h-dvh items-start justify-center pt-[28vh]"
        style={{ background: 'var(--color-bg)' }}
      >
        <LoadingIcon size="lg" />
      </div>
    );
  }

  if (!sessionReady || !session) {
    return (
      <Interstitial
        title="No active session"
        description="Something went wrong loading this session."
        primaryLabel="Go home"
        onPrimary={navigateHome}
      />
    );
  }

  return (
    <SessionPlayer
      key={session.id}
      sessionId={session.id}
      steps={sortedSteps}
      mode={sessionType}
      startIndex={startIndex}
      confidencePositions={confidencePositions}
      paasPositions={paasPositions}
      onExit={handleExit}
      onComplete={handleComplete}
      submitFn={submitFn}
    />
  );
}
